import React, { memo } from "react";
import { Backdrop, CircularProgress, Box, Typography } from "@mui/material";

function LoadingOverlay({ open, message = "Loading…" }) {
  return (
    <Backdrop
      open={open}
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        bgcolor: "rgba(13, 27, 42, 0.72)",
      }}
    >
      <Box textAlign="center">
        <CircularProgress color="inherit" aria-label={message} />
        <Typography variant="body2" sx={{ mt: 1 }}>{message}</Typography>
      </Box>
    </Backdrop>
  );
}

export default memo(LoadingOverlay);
